import React, { Component } from "react"
import { connect } from "react-redux"
import marked from "marked"
import PropTypes from "prop-types"
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import faKey from "@fortawesome/fontawesome-free-solid/faKey"
import faCheck from "@fortawesome/fontawesome-free-solid/faCheck"
import faExclamationTriangle from "@fortawesome/fontawesome-free-solid/faExclamationTriangle"
import faTimes from "@fortawesome/fontawesome-free-solid/faTimes"
// import { apiUrl } from '../config/config';
import { toggleModal } from "../lib/util"

class RegisterWarranty extends Component {
  state = {
    modalActive: false,
  }

  toggleModal = () => {
    this.setState(
      {
        modalActive: !this.state.modalActive,
      },
      () => {
        toggleModal(this.state.modalActive)
      }
    )
  }

  render() {
    const { pages, warranty, valid } = this.props
    const warrantyHint = pages.find((page) => page.name === "warranty_hint")
    const helpText = warranty.length > 0 ? (valid ? "必填" : "") : "必填"

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">保固卡流水號</label>
        </div>
        <div className="field-body">
          <div className="field">
            <p className="control is-expanded has-icons-left has-icons-right">
              <input
                className={valid ? "input is-success" : "input"}
                type="text"
                id="register-warranty-input"
                value={warranty}
                placeholder=""
                required
                onChange={(e) => {
                  let value = e.target.value
                  if (value.length > 14) {
                    value = value.substr(0, 14)
                  }
                  this.props.handleChange(value, "warranty")
                }}
              />
              <span className="icon is-small is-left">
                <FontAwesomeIcon className="icon" icon={faKey} />
              </span>
              <span className="icon is-small is-right">
                <FontAwesomeIcon
                  className="icon"
                  icon={valid ? faCheck : faExclamationTriangle}
                />
              </span>
            </p>
            <div className="help-wrapper">
              <p className="help is-danger">{helpText}</p>
              {warrantyHint && (
                <p className="help is-serial-hint" onClick={this.toggleModal}>
                  找不到流水號?
                </p>
              )}
            </div>
          </div>
        </div>

        {warrantyHint && (
          <div
            className={
              this.state.modalActive
                ? "modal modal-warranty-hint is-active"
                : "modal modal-warranty-hint"
            }
          >
            <div
              className="modal-background"
              role="button"
              tabIndex={0}
              onClick={this.toggleModal}
              onKeyUp={this.toggleModal}
            />
            <div
              className="modal-content"
              role="button"
              tabIndex={0}
              onClick={(e) => {
                e.stopPropagation()
              }}
              onKeyUp={(e) => {
                e.stopPropagation()
              }}
            >
              <div className="card">
                <button
                  className="card-close"
                  aria-label="close"
                  onClick={this.toggleModal}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
                {/*
                  <div className="card-content">
                      <div className="card-content-header">
                          <h1>如何找到流水號</h1>
                      </div>
                      <div className="card-content-body">
                          <p>如下圖範例，保固卡流水號碼可在紙本保固書右上角找到，如為舊款保固卡，則可在經銷商店章處找到。</p>
                      </div>
                      <div className="card-content-footer">
                          <img src={`${apiUrl}/uploads/ddb6be1c6d6d4b4989849c8a9bde018f.png`} alt="Warranty No Hint"></img>
                      </div>
                  </div>
                  */}

                <div
                  className="card-content"
                  dangerouslySetInnerHTML={{
                    __html: marked(warrantyHint.content),
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

RegisterWarranty.propTypes = {
  handleChange: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  pages: state.pages,
})

export default connect(mapStateToProps)(RegisterWarranty)



// WEBPACK FOOTER //
// ./src/components/RegisterWarranty.js